module.exports = __webpack_public_path__ + "img/yobi-da-yobi.a80dd30c.svg";